<template>
    <div class="myRmd_wrap">
        <top-component ref="topHeader"></top-component>
        <div class="myRmdlist_part">
            <h2 style="font-size:18px;line-height:40px;padding-bottom:30px;text-align:center;">我的荐购</h2>
            <div class="qiehuan">
                <el-form :inline="true" :model="form" class="demo-form-inline" ref="form" label-width="90px">
                    <el-form-item label="ISBN:" prop="isbn">
                        <el-input size="small" v-model="form.isbn" placeholder="请输入ISBN" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="书名:" prop="goodsName">
                        <el-input size="small" v-model="form.goodsName" placeholder="请输入书名" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="审核时间:" class="timepik">
                        <el-form-item prop="spstartdate" class="timepikbok">
                            <el-date-picker :picker-options="startTime" style="width:110px" value-format="yyyy-MM-dd" size="small" type="date" placeholder="开始时间" clearable v-model="form.spstartdate"></el-date-picker>-
                        </el-form-item>
                        <el-form-item prop="spenddate" class="timepikbok">
                            <el-date-picker :picker-options="endTime" style="width:110px" value-format="yyyy-MM-dd" size="small" type="date" placeholder="结束时间" clearable v-model="form.spenddate"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="作者:" prop="writer">
                        <el-input size="small" v-model="form.writer" placeholder="请输入作者" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="类型:" prop="goodsType" v-if="activeName != 'thrid'">
                        <el-select size="small" v-model="form.goodsType" filterable placeholder="请选择类型" clearable>
                            <el-option v-for="item in goodsTypeArr" :key="item.val" :label="item.name" :value="item.val" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="荐购时间:" class="timepik">
                        <el-form-item prop="bstartdate" class="timepikbok">
                            <el-date-picker :picker-options="startTime2" style="width:110px" value-format="yyyy-MM-dd" size="small" type="date" placeholder="开始时间" clearable v-model="form.bstartdate"></el-date-picker>-
                        </el-form-item>
                        <el-form-item prop="benddate" class="timepikbok">
                            <el-date-picker :picker-options="endTime2" style="width:110px" value-format="yyyy-MM-dd" size="small" type="date" placeholder="结束时间" clearable v-model="form.benddate"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <!-- <el-form-item label="审核状态:" prop="status">
                        <el-select size="small" v-model="form.status" filterable placeholder="请选择类型" clearable>
                            <el-option v-for="item in statusArr" :key="item.val" :label="item.name" :value="item.val" />
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item label="出版社" prop="publishName">
                        <el-input size="small" v-model="form.publishName" placeholder="请输入出版社"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="码洋" prop="isbn" v-show="activeName=='first'">
                        <el-form-item prop="di">
                            <el-input style="width:100px" size="small" v-model="form.di" placeholder="最低"></el-input>-
                        </el-form-item>
                        <el-form-item prop="gao">
                            <el-input style="width:100px" size="small" v-model="form.gao" placeholder="最高"></el-input>
                        </el-form-item>
                    </el-form-item> -->
                </el-form>
                <div style="text-align:center;padding:20px 0;">
                    <el-button size="small" type="primary" @click="getReguleRmdList" v-if="activeName!='thrid'">查询</el-button>
                    <el-button size="small" type="primary" @click="getNoBooklist" v-else>查询</el-button>
                    <el-button size="small" @click="reset">重置</el-button>
                </div>
            </div>
            
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="一般荐购" name="first"></el-tab-pane>
                <el-tab-pane label="荐购直邮" name="second"></el-tab-pane>
                <el-tab-pane label="无书目荐购" name="thrid"></el-tab-pane>
            </el-tabs>

            <div class="tablelist_box">    
                <el-radio-group v-model="form.status" @change="getReguleRmdList" v-if="activeName=='first'" style="margin-bottom:10px;">
                    <el-radio v-for="item in statusArr" :key="item.val" :label="item.val" v-if="item.val!=4">{{ item.name }}</el-radio>
                </el-radio-group>
                <el-radio-group v-model="form.status" @change="getReguleRmdList" v-else-if="activeName=='second'">
                    <el-radio v-for="item in statusArr" :key="item.val" :label="item.val">{{ item.name }}</el-radio>
                </el-radio-group>
                <el-radio-group v-model="form.status" @change="getNoBooklist" v-else-if="activeName=='thrid'">
                    <el-radio v-for="(item, index) in statusArr" :key="item.val" :label="item.val" v-if="index<4">{{ item.name }}</el-radio>
                </el-radio-group>
                <div class="tab_header" v-if="activeName=='second' && tableData.length>0">
                    <span style="font-size:12px;padding-left:10px;">
                        <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="checkAllHandle"></el-checkbox>&nbsp;全选
                    </span>
                    <el-button type="danger" v-if="form.status == '0'" icon="el-icon-delete" size="mini" @click="removeRmdMore" style="margin-left: 20px;float: right;">批量删除</el-button>
                </div>       
                <div class="rmdbooklist" style="min-height:430px;" v-if="activeName=='first' || activeName == 'second'">
                    <div class="nodata" v-if="tableData.length == 0">暂无数据！</div>
                    <div :class="{'bookinfo':true, 'ischecked':item.checked}" id="list" v-else v-for="(item, index) in tableData" :key="index">
                        <div class="infotop">
                            <div>
                                <el-checkbox v-model="item.checked" @change="checkHandle(index, item)"></el-checkbox>
                                <b>{{ item.createTime }}</b>
                                <span v-if="(item.status == 2 && activeName=='first') || (item.status == 1 && activeName=='second')" style="margin-left:10px;">订单号：{{ item.danhao }}</span>
                            </div>
                            <div class="sptime" v-if="item.status != 0">审核时间：{{ item.sptime }}</div>
                        </div>
                        <div class="bookinfo_box">
                            <div class="flex-box">
                                <div class="bookImg"><img :src="item.productImg" /></div>
                                <div class="bookdetail">
                                    <p class="bookname">{{ item.goodsName }}</p>
                                    <p>{{ item.writer }}</p>
                                    <p>{{ item.publishName }}</p>
                                    <p>{{ item.publishTime }}</p>
                                </div>
                            </div>
                            <div class="price">￥{{ item.price }}</div>
                            <div class="book_address" v-if="activeName=='second'">
                                <div class="address_info">
                                    <p><b>收货人：</b>{{ item.realname }}</p>
                                    <p><b>手机号：</b>{{ item.mobile }}</p>
                                    <p><b>收货地址：</b>{{ item.address }}</p>
                                    <p v-if="item.status == 4 || item.status == 5"><b>物流单号：</b>{{ item.fahuodanhao }}</p>
                                </div>
                                <el-button v-if="item.status==0" type="success" plain size="mini" @click="editAddress(item)">切换收货地址</el-button>
                            </div>
                            <div class="status">
                                <div class="status_wrap">
                                    <span class="qianshou green" v-if="item.status==5" @click="toBorrowRecord" style="cursor: pointer;" title="查看我的借阅记录">借阅中...</span>
                                    <span :class="{'red': item.status==0, 'green': item.status==1, 'gray': item.status==-1, 'yellow': item.status==2, 'blue': item.status==3}">{{ item.strstatus }}</span>
                                    <el-button type="danger" size="mini" plain @click="removeRmdByCarIds(item.cartId)" v-if="item.status==0 && roleInfo.ishavedel">删除</el-button>
                                    <el-button v-if="item.status==4 || item.status == 5" type="danger" size="mini" plain @click="viewWuliuInfo(item)">物流信息</el-button>
                                    <el-button v-if="item.status==4" type="danger" size="mini" @click="confirmReceipt(item)">确认收货</el-button>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="book_address" v-if="activeName=='second'">
                            <div class="address_info">
                                <span><b>收货人：</b>{{ item.realname }}</span>
                                <span><b>手机号：</b>{{ item.mobile }}</span>
                                <span><b>收货地址：</b>{{ item.address }}</span>
                            </div>
                            <div v-if="item.status==0"><el-button type="success" size="mini">切换收货地址</el-button></div>
                        </div> -->
                    </div>                     
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.pageNum" :page-size="form.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
                <div v-else>
                    <el-button type="danger" size="mini" @click="removeNobookMore()" style="margin:10px 0;" v-if="form.status==0">批量删除</el-button>
                    <el-table :data="tableData2" border :cell-style="{ padding: 5 + 'px' }" :header-cell-style="{ background: '#F5F7FA', color: '#606266' }" @selection-change="handleSelectionChange" @select-all="selectAll">
                        <el-table-column type="selection" width="50" align="center"> </el-table-column>
                        <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                        <el-table-column prop="isbn" label="ISBN" :show-overflow-tooltip='true' align="center"></el-table-column>
                        <el-table-column prop="bookname" label="书名" :show-overflow-tooltip='true' align="center"></el-table-column>
                        <el-table-column prop="author" label="作者" align="center" width="100px"></el-table-column>
                        <el-table-column prop="pubname" label="出版社" align="center" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="pubtime" label="出版年月" align="center" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="price" label="码洋" align="center" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="createdate" label="荐购时间" :show-overflow-tooltip='true' align="center"></el-table-column>
                        <el-table-column prop="sptime" label="审核时间" :show-overflow-tooltip='true' align="center"></el-table-column>
                        <el-table-column prop="statusstr" label="审核状态" :show-overflow-tooltip='true' align="center"></el-table-column>
                        <el-table-column prop="remark" label="驳回原因" :show-overflow-tooltip='true' align="center" v-if="form.status=='-1'"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="100" align="center" v-if="form.status=='' ||form.status=='0'">
                            <template slot-scope="scope">
                                <el-button type="primary" style="margin-left: 10px;" v-if="scope.row.status==0" plain size="mini" @click="editNobook(scope.row)">修改</el-button>
                                <el-button type="danger" v-if="scope.row.status==0" plain size="mini" @click="removeNobookByid(scope.row.pkid)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>                    
                    <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="form.pageNum" :page-size="form.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total2"></el-pagination>
                </div>
            </div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>
<script>
    import TopComponent from '../Components/TopComponentcopy.vue'
    import BottomComponent from '../Components/BottomComponent.vue'
    import { getRmdList, removeRmd, changeRmdAddree, noBooklist, removeNobook, getConfirm } from '@/api/manage.js'
    import popup from "@/common/plugin/dialog/index.js";
    import addressManage from '../Components/addressManage.vue'
    import wuliuInfo from '../../components/wuliu.vue'
    import editNobook from '../Xtch/noBooklist/addBook.vue'

    export default {
        name: 'MyPurchase',
        data() {
            let vm = this;
            return {
                // loading:false,
                activeName: 'first',
                roleInfo:JSON.parse(localStorage.getItem('roleInfo')),
                form: {
                    userId: JSON.parse(localStorage.getItem('user')).gid,
                    isbn: '',
                    goodsName: '',
                    writer: '',
                    goodsType: '',
                    status: '',
                    spstartdate: '',
                    spenddate: '',
                    bstartdate: '',
                    benddate: '',
                    pageNum: 1,
                    pageSize: 10
                },
                goodsTypeArr:[
                    { name: '纸质书', val: 0 },
                    { name: '电子书', val: 1 }
                ],
                statusArr:[
                    { name: '全部', val: '' },
                    { name: '未审核', val: '0' },
                    { name: '审核通过', val: '1' },
                    { name: '审核驳回', val: '-1' },
                    { name: '已发货', val: '4' },
                    { name: '已签收', val: '5' },
                    { name: '已汇总', val: '2' },
                    { name: '已收订', val: '3' },
                ],
                tableData:[],
                total:0,
                startTime: {
                    disabledDate: time => {
                        if (vm.form.spenddate) {
                            return (
                                time.getTime() > new Date(vm.form.spenddate).getTime()
                            );
                        }
                    }
                },
                endTime: {
                    disabledDate: time => {
                        if (vm.form.spstartdate) {
                            return (
                                time.getTime() < new Date(vm.form.spstartdate).getTime()
                            );
                        }
                    }
                },
                startTime2: {
                    disabledDate: time => {
                        if (vm.form.benddate) {
                            return (
                                time.getTime() > new Date(vm.form.benddate).getTime()
                            );
                        }
                    }
                },
                endTime2: {
                    disabledDate: time => {
                        if (vm.form.bstartdate) {
                            return (
                                time.getTime() < new Date(vm.form.bstartdate).getTime()
                            );
                        }
                    }
                },
                checkAll: false,
                isIndeterminate:false,
                checkedData:[],//记录多选数据
                tableData2:[],
                multipleSelection:[],//多选
                total2:0,
            }
        },
        components:{
            TopComponent, BottomComponent
        },
        created(){
            let vm = this;
            console.log(roleInfo);
        }, 
        mounted(){
            let vm = this;
            !JSON.parse(localStorage.getItem('roleInfo')).isdirectmail ? vm.activeName = 'first' : vm.activeName = 'second';
            vm.getReguleRmdList();
        },       
        methods: {
            //查看借阅
            toBorrowRecord(){
                this.$router.push({ name: 'myBorrowRecord'});
            },
            //确认签收
            confirmReceipt(item){
                let vm = this;
                vm.$confirm("确定要签收吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    getConfirm({
                        cartids: item.cartId
                    }).then(res => {
                        if(res.status){
                            vm.$alert("已签收成功，借阅成功！请准时归还至学校图书馆！", {
                                cancelButtonText: '已知晓',
                                confirmButtonText: '查看我的借阅记录',
                                callback: action => {
                                    vm.$router.push({ name: 'myBorrowRecord'});
                                }
                            });
                            vm.getReguleRmdList(); //刷新列表
                        }
                    }).catch(err => {

                    });
                }).catch(() => {

                });
            },
            //查看物流信息
            viewWuliuInfo(item){
                let vm = this;
                vm.wuliu_pop = popup('<wuliu-info @close="close" @submit="submit" :wuliudanhao="wldanhao" :cartid="cartId" />', {
                    option: {
                        title: '查看物流信息',
                        width: '600px',
                        height: '800px'
                    },
                    popup: {
                        data() {
                            return {
                                cartId: item.cartId,
                                wldanhao: item.fahuodanhao
                            };
                        },
                        components: {
                            wuliuInfo
                        },
                        methods: {
                            submit(data) {
                                vm.wuliu_pop.hide();
                            },
                            close(){
                                vm.wuliu_pop.hide();
                            }
                        }
                    }
                });
                vm.wuliu_pop.show();
            },
            //编辑收货地址
            editAddress(row){
                let vm = this;
                vm.edit_pop = popup('<address-manage @close="close" @submit="submit" :addressid="addressId" :changetype="type" />', {
                    option: {
                        title: '切换收货地址',
                        width: '800px'
                    },
                    popup: {
                        data() {
                            return {
                                type:1, //1：修改地址
                                addressId: row.useraddrpkid
                            };
                        },
                        components: {
                            addressManage
                        },
                        methods: {
                            submit(data) {
                                //修改
                                changeRmdAddree({
                                    cartid:row.cartId,
                                    sheng: data.sheng,
                                    shi: data.shi,
                                    qu: data.qu,
                                    address: data.address,
                                    username: data.username,
                                    mobile: data.mobile,
                                    useraddrpkid: data.pkid,//地址pkid
                                }).then(res => {
                                    if(res.status){
                                        vm.$message({
                                            message: "切换收货地址成功！",
                                            type: "success"
                                        });
                                        vm.activeName = 'second';
                                        vm.getReguleRmdList();
                                    }
                                }).then(err => {

                                })
                                vm.edit_pop.hide();
                            },
                            close(){
                                vm.edit_pop.hide();
                            }
                        }
                    }
                });
                vm.edit_pop.show();
            },
            //保存编辑地址
            //重置
            reset(){
                let vm = this;
                vm.$refs.form.resetFields();
            },
            handleClick(tab, event) {
                let vm = this;
                if(tab.index == 2){
                    vm.getNoBooklist();
                }else{
                    vm.getReguleRmdList();
                }
            },
            handleSelectionChange (selection) {
                // console.log(selection)
                this.multipleSelection = selection;
            },
            selectAll(selection){
                // console.log(selection)
                this.multipleSelection = selection;
            },
            //获取无书目荐购列表记录
            getNoBooklist(){
                let vm = this;
                vm.form.pageNum = 1;
                vm.form.pageSize = 20;
                noBooklist({                        
                    userId: JSON.parse(localStorage.getItem('user')).gid,
                    bookname: vm.form.goodsName,
                    isbn: vm.form.isbn,
                    adminState: '', //用户身份
                    status: vm.form.status,
                    bstartdate: vm.form.bstartdate,
                    benddate: vm.form.benddate,
                    pageNum: vm.form.pageNum,
                    pageSize: vm.form.pageSize,
                }).then(res => {
                    if(res.status){
                        vm.tableData2 = res.data.list;
                        vm.total2 = res.data.total;
                    }
                }).catch(err => {

                });
            },
            //编辑无书目
            editNobook(row){
                let vm = this;            
                vm.editnobook = popup('<edit-nobook @ok="submit" @close ="close" :data="data" :type="type"></edit-nobook>', {
                    option: {
                        title: '修改无书目信息',
                        width: "490px",
                    },
                    popup: {
                        data() {
                            return {
                                data: row,
                                type:1,
                            }
                        },
                        components: {
                            editNobook,
                        },
                        methods: {
                            submit(data) {
                                vm.editnobook.hide();      
                                vm.getNoBooklist();//刷新无书目列表                   
                            },
                            close(data) {
                                vm.editnobook.hide();
                            },
                        }
                    }
                });
                vm.editnobook.show();
            },
            //批量删除无书目荐购
            removeNobookMore(){
                let vm = this,
                    ids = [];
                vm.multipleSelection.forEach((item, index) => {
                    ids.push(item.pkid);
                });
                if(ids.length > 0){
                    vm.removeNobookByid(ids.join());
                }else{                   
                    vm.$message({
                        message: "请至少勾选中一本书进行删除！",
                        type: "warning"
                    });
                }
            },
            removeNobookByid(pkids){
                let vm = this;
                vm.$confirm("确定要删除吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    removeNobook({
                        pkid: pkids
                    }).then(res => {
                        if(res.status){        
                            vm.$message({
                                message: "删除成功！",
                                type: "success"
                            });
                            vm.getNoBooklist();
                        }
                    }).catch(err => {

                    });
                }).catch(() => {

                });
            },
            //建构列表
            getReguleRmdList(){
                let vm = this,
                    obj = vm.form;
                vm.activeName == 'first' ? obj.rmdtype = 0 : obj.rmdtype = 1;
                // vm.loading = true;
                vm.checkAll = false;
                vm.isIndeterminate = false;
                vm.checkedData = [];
                const loading = this.$loading({
                    target: document.querySelector('#list'),
                    lock: true,
                    text: '数据加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(225, 225, 225, 0.5)'
                });
                getRmdList(obj).then(res => {
                    if(res.status){
                        vm.tableData = res.data.list;
                        vm.total = res.data.total;
                        loading.close();
                        vm.tableData.forEach((ele, i) => {
                            vm.$set(vm.tableData[i], 'checked', false);
                        });
                    }
                }).catch(err => {
                    loading.close();
                });
            },
            removeRmdMore(){
                let vm = this,
                    ids = [];
                vm.checkedData.forEach((item, index) => {
                    ids.push(item.cartId);
                });
                if(ids.length > 0){
                    vm.removeRmdByCarIds(ids.join());
                }else{                   
                    vm.$message({
                        message: "请至少勾选中一本书进行删除！",
                        type: "warning"
                    });
                }
            },
            removeRmdByCarIds(ids){
                let vm = this;                    
                vm.$confirm("确定要删除吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    removeRmd({cartId: ids}).then(res => {
                        if(res.status){        
                            vm.$message({
                                message: "删除成功！",
                                type: "success"
                            });
                            vm.getReguleRmdList();
                        }
                    }).catch(err => {
                    });
                }).catch(() => {

                });
            },
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                let vm = this;
                vm.form.pageSize = val;
                vm.getReguleRmdList();
            },
            handleCurrentChange(val){
                let vm = this;
                console.log(`当前页: ${val}`);
                vm.form.pageNum = val;
                vm.getReguleRmdList();
            },
            handleSizeChange2(val){
                console.log(`每页 ${val} 条`);
                let vm = this;
                vm.form.pageSize = val;
                vm.getNoBooklist();
            },
            handleCurrentChange2(val){
                let vm = this;
                console.log(`当前页: ${val}`);
                vm.form.pageNum = val;
                vm.getNoBooklist();
            },
            //单个批量勾选
            checkHandle(index, item){
                console.log(this.tableData[index].checked);
                let vm = this,
                    checkedlist = [];
                // vm.$set(vm.tableData[index], 'checked', vm.tableData[index].checked);
                vm.tableData.forEach((ele, i) => {
                    if(ele.checked){
                        checkedlist.push(ele);
                    } 
                });
                if(checkedlist.length == vm.tableData.length){
                    vm.checkAll = true;
                    vm.isIndeterminate = false;
                }else if(checkedlist.length < vm.tableData.length){
                    vm.checkAll = false;
                    if(checkedlist.length == 0){
                        vm.isIndeterminate = false;
                    }else{
                        vm.isIndeterminate = true;
                    }
                }
                vm.checkedData = checkedlist;
            },
            checkAllHandle(){
                let vm = this;
                vm.isIndeterminate = false;
                if(!vm.checkAll){
                    vm.tableData.forEach((ele, i) => {
                        vm.$set(vm.tableData[i], 'checked', false);
                    });
                    vm.checkedData = [];
                }else{
                    vm.tableData.forEach((ele, i) => {
                        vm.$set(vm.tableData[i], 'checked', true);
                    });
                    vm.checkedData = vm.tableData;
                }
            },
        }
    }

</script>

<style lang="scss">
    .myRmdlist_part{
        width: 1200px;
        margin:20px auto;
        background-color: #fff;
        padding:20px;
        .el-input--suffix .el-input__inner{
            padding-right: 0;
        }
        .el-form-item__label{
            padding-right:6px;
        }
        .el-form--inline .el-form-item__content{
            width:270px;
        }
        .el-form--inline .timepik .el-form-item__content{
            width:275px;
        }
        .el-form--inline .timepik .timepikbok{
            margin-right: 0;
        }
        .el-form--inline .timepik .timepikbok .el-form-item__content{
            width:120px;
        }
        .el-select{
            width:100%;
        }
        .el-form-item{
            margin-bottom: 5px;
        }        
        .tab_header{
            height:28px;
            line-height:28px;
            background-color: #daf3ff;
            border:1px solid #daf3ff;
            padding:3px 10px 3px 0;
            margin-top:10px;
        }
        .nodata{
            padding: 30px;
            // font-size:12px;
            text-align:center;
            color:#999;
        }
        .ischecked{
            .bookinfo_box{
                background-color:#fffcec;
            }
        }
        .rmdbooklist{
            .bookinfo{
                // margin-bottom: 10px;
                .infotop{
                    display: flex;
                    justify-content: space-between;
                    background-color: #eaf8ff;
                    border-top:1px solid #daf3ff;
                    border-left:1px solid #daf3ff;
                    border-left:1px solid #daf3ff;
                    padding:5px 10px;
                    font-size:12px;
                    b{
                        color:#666;
                    }
                }
                .bookinfo_box{
                    display: flex;
                    justify-content: space-between;
                    border-left:1px solid #daf3ff;
                    border-right:1px solid #daf3ff;
                    border-bottom:1px solid #daf3ff;
                    // padding: 10px;
                    .bookImg{
                        display: flex;
                        align-items: center;
                        width: 80px;
                        min-height:105px;
                        margin: 5px;
                        img{
                            width:100%;
                        }
                    }
                    .price{
                        display: flex;
                        align-items: center;
                        font-weight: bold;
                        font-size: 16px;
                        color:#ff2a2a;
                        width:100px;
                    }
                    .status{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width:105px;
                        text-align: center;
                        font-weight: bold;
                        font-size:12px;
                        border-left:1px solid #daf3ff;
                        .status_wrap{
                            >span{
                                display: block;
                                line-height:30px;
                                &.qianshou:hover{
                                    text-decoration: underline;
                                }
                            }
                            >span.red{
                                color:#ff2a2a;
                            }
                            >span.green{
                                color:#01a82b;
                            }
                            >span.gray{
                                color:#d3d3d3;
                            }
                            >span.yellow{
                                color:#ffa010;
                            }
                            >span.blue{
                                color:#50bff3;
                            }
                            .el-button+.el-button{
                                margin:5px 0px;
                            }
                        }
                    }
                    .bookdetail{
                        width:480px;
                        color:#999;
                        font-size:12px;
                        padding: 15px 10px;
                        .bookname{
                            font-weight: bold;
                            color:#333;
                            font-size:14px;
                            padding-bottom: 8px;
                        }
                    }
                    .book_address{
                        width:400px;
                        padding:10px;
                        border-left:1px solid #daf3ff;
                        .address_info{
                            font-size:12px;
                            // height: 28px;
                            line-height: 24px;
                            p{
                                >b{
                                    color:#999;
                                }
                            }
                        }

                    }
                }
                // .book_address{
                //     display: flex;
                //     justify-content: space-between;
                //     border: 1px solid #daf3ff;
                //     padding: 3px 10px;
                //     .address_info{
                //         font-size:14px;
                //         height: 28px;
                //         line-height: 28px;
                //         span{
                //             padding-right:15px;
                //             >b{
                //                 color:#999;
                //             }
                //         }
                //     }

                // }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/myRmdList.vue